import { Drawer, DrawerProps } from 'components/Drawer/DrawerDeprecated';
import { Text } from 'components/Text/Text';

import { AddTrackableFileForm } from './AddTrackableFileForm';

export type AddTrackableFileDialogProps = DrawerProps & {
  trackableListId: string;
  trackableItemId: string;
  itemName: string;
  onSuccess?: () => void;
};

export function AddTrackableFileDialog({
  trackableListId,
  trackableItemId,
  itemName,
  open,
  onClose,
  onSuccess,
}: AddTrackableFileDialogProps) {
  return (
    <Drawer title="Add reference images" open={open} onClose={onClose}>
      <Text type="paragraph">
        Upload reference images for "{itemName}". These images will be used to
        identify this item in video streams.
      </Text>

      <AddTrackableFileForm
        trackableListId={trackableListId}
        trackableItemId={trackableItemId}
        onSuccess={() => {
          onClose?.();
          onSuccess?.();
        }}
      />
    </Drawer>
  );
}
